import { render, staticRenderFns } from "./VSyncInput.vue?vue&type=template&id=0eec1c7b&"
import script from "./VSyncInput.vue?vue&type=script&lang=ts&"
export * from "./VSyncInput.vue?vue&type=script&lang=ts&"
import style0 from "./VSyncInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports